.empty {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 13px;
  padding: 24px 20px;
}

.kicker {
  margin: 0;
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--color-accent);
}

.headline {
  margin: 0;
  font-size: 27px;
  font-weight: 500;
  line-height: 1.12;
  letter-spacing: -0.02em;
  max-width: 15ch;
}

.body {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: rgb(233 233 237 / 0.55);
  max-width: 32ch;
}

.row {
  display: flex;
  gap: 8px;
  width: 100%;
  max-width: 420px;
}

.row > .urlInput {
  min-height: 44px;
}

.row > button {
  min-height: 44px;
  padding-inline: 16px;
  flex: none;
}

.upload {
  position: relative;
  width: 100%;
  max-width: 420px;
  min-height: 44px;
  cursor: pointer;
}

.fileInput {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.error {
  margin: 0;
  font-size: 12px;
  color: var(--color-accent-300);
  background: var(--color-accent-800);
  padding: 7px 10px;
  border-radius: 6px;
}

@media (min-width: 900px) {
  .empty {
    gap: 14px;
    padding: 0 64px;
  }

  .headline {
    font-size: 42px;
    line-height: 1.08;
    letter-spacing: -0.025em;
    max-width: 18ch;
  }

  .body {
    font-size: 15px;
    line-height: 1.55;
    max-width: 52ch;
  }

  .error {
    font-size: 13px;
    padding: 9px 12px;
  }
}
